var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopNavDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 28 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.901 4.135A13.852 13.852 0 0014 0c-3.74 0-7.253 1.468-9.901 4.135C1.45 6.8 0 10.35 0 14.123c0 3.773 1.455 7.317 4.099 9.989A13.833 13.833 0 0014 28.246c3.74 0 7.253-1.468 9.901-4.134C26.55 21.445 28 17.896 28 14.123c0-3.772-1.455-7.317-4.099-9.988zM14 26.76c-6.908 0-12.526-5.668-12.526-12.637C1.474 7.155 7.092 1.487 14 1.487c6.908 0 12.526 5.668 12.526 12.636 0 6.969-5.618 12.637-12.526 12.637z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.42c.405 0 .737.2.737.442v.883c0 .241-.332.44-.737.44-.405 0-.737-.199-.737-.44v-.883c0-.242.332-.441.737-.441zm0 4.498c.405 0 .737.222.737.496v9.916c0 .275-.332.496-.737.496-.405 0-.737-.221-.737-.496v-9.92c0-.27.332-.492.737-.492z"
  }))));
}

export default SvgTopNavDetails;